import { AloSecurityItem } from '@/models/alo/AloSecurityItem';
import { ApiUserRole } from './ApiUserRole';

export enum SecurityItemsKeys  {
    DEBUG_LOG = "DEBUG_LOG"
}


export const getDefaultSecurityRights = (): {[index: string]: AloSecurityItem}   => { return {
        [SecurityItemsKeys.DEBUG_LOG]: {enable:false, visible:false}
    }
}

export const calculSecurityRights = (role: ApiUserRole|null) => {
    if(role){
        return SecurityRightsByRoles[role]
    }
    else{
        return getDefaultSecurityRights()
    }
}

export const SecurityRightsByRoles: {[index: string]: {[index: string]: AloSecurityItem} } = {
    [ApiUserRole.CentralWeb]:{
        [SecurityItemsKeys.DEBUG_LOG]: {enable:false, visible:false}
    },
    [ApiUserRole.Admin]:{
        [SecurityItemsKeys.DEBUG_LOG]: {enable:false, visible:false}
    }
}